module.exports = __webpack_public_path__ + "assets/img/tracked-box1-icon3.480888ae.svg";